import { ConfigData } from './types';

const IAM_URL_NAME = 'hd:iam_url';
const CLIENT_ID_NAME = 'hd:client_id';
const REDIRECT_URI_NAME = 'hd:redirect_uri';

let iamUrl = sessionStorage.getItem(IAM_URL_NAME);
let clientId = sessionStorage.getItem(CLIENT_ID_NAME);
let redirectUri = sessionStorage.getItem(REDIRECT_URI_NAME);

export function getConfig(): ConfigData | undefined {
  if (iamUrl && clientId && redirectUri) {
    return { iamUrl, clientId, redirectUri };
  }
}

export function storeConfig(configData: ConfigData): void {
  iamUrl = configData.iamUrl;
  clientId = configData.clientId;
  redirectUri = configData.redirectUri;
  sessionStorage.setItem(IAM_URL_NAME, iamUrl);
  sessionStorage.setItem(CLIENT_ID_NAME, clientId);
  sessionStorage.setItem(REDIRECT_URI_NAME, redirectUri);
}

export function clearConfig(): void {
  sessionStorage.removeItem(IAM_URL_NAME);
  sessionStorage.removeItem(CLIENT_ID_NAME);
  sessionStorage.removeItem(REDIRECT_URI_NAME);
  iamUrl = null;
  clientId = null;
  redirectUri = null;
}
